import { AdaptiveCardWrapper, FlexBox } from "@brg/ui";
import { FC } from "react";
import { ProjectsGridNew } from "shared/components/grids";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { computeCard } from "shared/helpers/types/computed/ComputeCard";
import { getCardNumber } from "shared/helpers/utils/getCardNumber";
import { isServer } from 'shared/constants/isServer';

const CardComponent = isServer ? {} : require('adaptive-cards');

const getCertTemplateType = (card?: any): string =>
    card?.templateType?.nameComponent
    || card?.templateData?.typeTemplate
    || 'WarholCardA4';

const getCertUpperTitle = (card?: any): string =>
    card?.templateData?.customFields?.find((field: any) => field?.typeField === 'upperTitle')?.data
    || card?.templateData?.upperTitle
    || card?.templateData?.date
    || '';

const CertificateMasterCard: FC<any> = (props) => (
    <CardComponent.MasterCard {...props} image="" logo="" />
);

export const DesignerDiscountTab: FC<{ data?: any[], isLoading?: boolean, isCert?: boolean }> = ({ data, isLoading, isCert }) => {
    return (
        <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
            <ProjectsGridNew k={20} isLoading={isLoading} columns={4} mobileColumns={2}>
                {data?.map((card, index) => {
                    return (
                        <ProjectCardNew
                            project={computeCard(card) as any}
                            linkTo={process.env.REACT_APP_URL_GALLERY + '/card/' + card?.cardId}
                            isEditable={false}
                            withoutGoToProject
                            withoutRepost
                            isCanNotBeDraft
                            //@ts-ignore
                            key={(card?.cardId || '') + index}
                            {...computeCard(card)}
                            card={card}
                            isCert={isCert}
                        />
                    )
                })}
            </ProjectsGridNew>
        </FlexBox>
    )
}

export const DesignerCertCardImage: FC<{ card?: any }> = ({ card }) => {
    const templateType = getCertTemplateType(card);
    const isCertificateCard = String(templateType).startsWith('CertificateCard');
    const upperTitle = getCertUpperTitle(card);

    return (
        <AdaptiveCardWrapper
            cardProps={{
                data: {
                    ...card,
                    number: getCardNumber(card?.sequenceItem?.number || card?.templateData?.number),
                },
                templateType,
                upperTitle,
            }}
            images={card?.images}
        >
            {isCertificateCard ? <CertificateMasterCard /> : <CardComponent.MasterCard />}
        </AdaptiveCardWrapper>
    )
}
import { AdaptiveCardWrapper, FlexBox } from "@brg/ui";
import { FC } from "react";
import { ProjectsGridNew } from "shared/components/grids";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { computeCard } from "shared/helpers/types/computed/ComputeCard";
import { getCardNumber } from "shared/helpers/utils/getCardNumber";
import { isServer } from 'shared/constants/isServer';

const CardComponent = isServer ? {} : require('adaptive-cards');

const getCertTemplateType = (card?: any): string =>
    card?.templateType?.nameComponent
    || card?.templateData?.typeTemplate
    || 'WarholCardA4';

const getCertUpperTitle = (card?: any): string =>
    card?.templateData?.customFields?.find((field: any) => field?.typeField === 'upperTitle')?.data
    || card?.templateData?.upperTitle
    || card?.templateData?.date
    || '';

const CertificateMasterCard: FC<any> = (props) => (
    <CardComponent.MasterCard {...props} image="" logo="" />
);

export const DesignerDiscountTab: FC<{ data?: any[], isLoading?: boolean, isCert?: boolean }> = ({ data, isLoading, isCert }) => {
    return (
        <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
            <ProjectsGridNew k={20} isLoading={isLoading} columns={4} mobileColumns={2}>
                {data?.map((card, index) => {
                    return (
                        <ProjectCardNew
                            project={computeCard(card) as any}
                            linkTo={process.env.REACT_APP_URL_GALLERY + '/card/' + card?.cardId}
                            isEditable={false}
                            withoutGoToProject
                            withoutRepost
                            isCanNotBeDraft
                            //@ts-ignore
                            key={(card?.cardId || '') + index}
                            {...computeCard(card)}
                            card={card}
                            isCert={isCert}
                        />
                    )
                })}
            </ProjectsGridNew>
        </FlexBox>
    )
}

export const DesignerCertCardImage: FC<{ card?: any }> = ({ card }) => {
    const templateType = getCertTemplateType(card);
    const isCertificateCard = String(templateType).startsWith('CertificateCard');
    const upperTitle = getCertUpperTitle(card);

    return (
        <AdaptiveCardWrapper
            cardProps={{
                data: {
                    ...card,
                    number: getCardNumber(card?.sequenceItem?.number || card?.templateData?.number),
                },
                templateType,
                upperTitle,
            }}
            images={card?.images}
        >
            {isCertificateCard ? <CertificateMasterCard /> : <CardComponent.MasterCard />}
        </AdaptiveCardWrapper>
    )
}
